export const DEFAULT_WATCHLIST_SYMBOLS: string[] = [
  "EURUSD",
  "GBPUSD"
];

export const MAX_WATCHLIST_SYMBOLS = 50;
